var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-tabs-slots"},[_c('am-tabs',{attrs:{"tabs":_vm.tabs,"minWidth":true},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_vm._t("default",null,{"selected":_vm.selected})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }